import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { IPetsySavedQuoteErrorPopupProps } from "./PetsySavedQuoteErrorPopup.types";
import {
  Modal,
  Button,
} from "react-bootstrap";
import "./PetsySavedQuoteErrorPopup.scss";
import _ from "lodash";

export default function PetsySavedQuoteErrorPopup(props: IPetsySavedQuoteErrorPopupProps) {
  const [enableButton, setEnableButton] = React.useState<boolean>(true);
  const [renderKey, setRenderKey] = React.useState(0);
  const navigate = useNavigate();

  function modalClose() {
    navigate("step-1");
    setEnableButton(false);
    props.onClose();
  }

  const optionRef = React.useRef<any>();
  return (
    <>
      <Modal
        className="flc_petsy-expired-popup"
        show={props.show}
        onHide={modalClose}
        backdrop="static"
        keyboard={false}
        fullscreen="sm-down"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Quote No Longer Available
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center" ref={optionRef}>
          It looks like the quote you were viewing has already been purchased and is no longer available. <br/>For a new quote or any questions, please contact us on 1300 952 790 or <a href="#" onClick={modalClose}>start a new quote.</a>
        </Modal.Body>
        <div className="">
          <Button
            key={renderKey}
            className="flc_next-button btn mt-3 py-3 mt-4 btn-primary"
            onClick={modalClose}
          >
            Close
          </Button>
        </div>
      </Modal>
    </>
  );
}
